import React from "react";

import classNames from "classnames";
import { ReactSVG } from "react-svg";

import { ParticipantTypes, TreeNode } from "@api/graphql";
import { RectangleLine } from "@assets/icons";
import { ParticipantStatusBadge } from "@components/account_profile/ParticipantStatusBadge";

import styles from "./ArtistTree.module.scss";

export interface TreeNodeWithChildren extends TreeNode {
  children?: TreeNodeWithChildren[];
}
interface ArtistTreeProps {
  node: TreeNodeWithChildren;
}

const Percentage = ({ deceased, percentage }: { deceased: boolean; percentage: number }) => {
  return (
    <div className={classNames(styles.infoPill)}>
      <div className={classNames(styles.medium)}>Split</div>
      <div className={classNames(styles.percentage, { [styles.deceased]: deceased })}>{percentage}%</div>
    </div>
  );
};
const Name = ({
  isArtist,
  name,
  participantType,
  companyName,
}: {
  isArtist: boolean;
  name: string;
  participantType?: ParticipantTypes[];
  companyName?: string;
}) => {
  const isCollaborationAccount = participantType?.includes(ParticipantTypes.COLLABORATION);
  return (
    <div>
      <div className={classNames(styles.medium)}> {isArtist ? "Associated Artist" : "Beneficiary"}</div>
      <div className={classNames(styles.name)}>{isCollaborationAccount ? companyName : name}</div>
    </div>
  );
};

const ArtistTree = ({ node }: ArtistTreeProps) => {
  const { name, overall_royalty_percentage, deceased, participantType, companyName } = node.attributes;
  const isAssociatedArtist = !node.parent_nodes || node.parent_nodes.length === 0;
  return (
    <>
      <div
        className={classNames({ [styles.beneficiariesRow]: !isAssociatedArtist })}
        style={{ paddingLeft: `${node.depth * 50}px` }}
      >
        {!isAssociatedArtist && (
          <>
            <ReactSVG className={classNames(styles.lineSVG)} src={RectangleLine} />
            <Percentage deceased={deceased} percentage={overall_royalty_percentage} />
          </>
        )}
        <div className={classNames(styles.nameContainer)}>
          <Name
            isArtist={isAssociatedArtist}
            name={name}
            participantType={participantType as ParticipantTypes[]}
            companyName={companyName}
          />
          {!isAssociatedArtist && (
            <div className={classNames(styles.profileStatus)}>
              <ParticipantStatusBadge status={deceased} />
            </div>
          )}
        </div>
      </div>
      {/* Render children recursively */}
      {node.children &&
        node.children.length > 0 &&
        node.children.map((childNode) => <ArtistTree key={childNode.node_id} node={childNode} />)}
    </>
  );
};

export default ArtistTree;
